import BiggestExchangeImage from "../../assets/images/home-images/main_banner.webp";
import HomePageSlider from "../../assets/images/home-images/slider1.gif"
import SportsImg from "../../assets/images/home-images/sportbook.png"
import BannerSports from "../../assets/images/home-images/banner-sport1.png"
import LiveEventsImage from "../../assets/images/home-images/cricket_banner.webp";
import SportsBookImage from "../../assets/images/home-images/cricket_banner2.webp";
import AviatorImage from "../../assets/images/home-images/Avaitor.gif";
import Mac88CasinoImage from "../../assets/images/home-images/mac88-casino.webp";
import Mac88FunGamesImage from "../../assets/images/home-images/mac88-fun-games.webp";
import Mines from "../../assets/images/home-images/Mines.gif";
import FunGamesGif from "../../assets/images/home-images/FunGames.gif";
import ColorPrediction from "../../assets/images/home-images/ColorPrediction.gif";
import HorseRacingImage from "../../assets/images/home-images/horse-racing.webp";
import GreyhoundRacingImage from "../../assets/images/home-images/greyhound-racing.webp";
import {
  CASINO_ROUTE,
  CRICKET_ROUTE,
  EXCHANGE_SPORTS_ROUTE,
  FOOTBALL_ROUTE,
  POPULAR_EVENTS_ROUTE,
  SPORTS_BOOK_ROUTE,
} from "@hypexone/uicore";

export const gamesImagesData: {
  title: string;
  imageSrc: string;
  alt: string;
  url?: string;
  customClassName?: string;
}[] = [
  {
    title: "",
    imageSrc: HomePageSlider,
    alt: "biggest-exch",
    url: POPULAR_EVENTS_ROUTE,
    customClassName: "col-span-4 md:col-span-6 h-[72px] md:h-[225px]",
  },
  {
    title: 'Sports',
    imageSrc: BannerSports,
    alt: "live-events",
    url: `${EXCHANGE_SPORTS_ROUTE}${FOOTBALL_ROUTE}`,
    customClassName: "col-span-4 md:col-span-3 md:h-auto",
  },
  {
    title: 'Sports Book',
    imageSrc: SportsImg,
    url: SPORTS_BOOK_ROUTE,
    alt: "sportsbook",
    customClassName: "col-span-4 md:col-span-3 md:h-auto",
  },
];

export const HorseRacingImagesData: {
  imageSrc: string;
  alt: string;
  url?: string;
  customClassName?: string;
}[] = [
  {
    imageSrc: HorseRacingImage,
    url: "/exchange_sports/horserace",
    alt: "horse-racing",
    customClassName: "col-span-2 md:col-span-3 h-[102px] md:h-[333px]",
  },
  {
    imageSrc: GreyhoundRacingImage,
    url: "/exchange_sports/greyhound",
    alt: "greyhound-racing",
    customClassName: "col-span-2 md:col-span-3 h-[102px] md:h-[333px]",
  },
];